import { UserStatus, VerifierStaffRole } from 'src/api';

export enum FormFields {
  userStatus = 'userStatus',
  businessRole = 'businessRole',
}

export type FormValues = {
  [FormFields.userStatus]: UserStatus;
  [FormFields.businessRole]: VerifierStaffRole;
};
